import { Link } from "react-router";
import { Logo } from "@baze/brand";
import { buttonClass } from "@/components/ui/button";
import { BrandShapes } from "@/components/BrandShapes";
import { t } from "@/i18n/id";
import { useDocumentTitle } from "@/lib/document-title";

export function NotFoundPage({ inShell = false }: { inShell?: boolean }) {
  useDocumentTitle(t.errors.notFoundTitle);
  return (
    <main className={inShell ? "container-shell py-16" : "bg-glow flex min-h-dvh flex-col bg-paper"}>
      {!inShell ? (
        <header className="container-shell flex h-16 items-center">
          <Link to="/" aria-label={t.brand.product}>
            <Logo />
          </Link>
        </header>
      ) : null}
      <div className="flex flex-1 flex-col items-center justify-center gap-5 px-6 py-16 text-center">
        <p className="section-label">404</p>
        <BrandShapes className="h-28 w-48" />
        <h1 className="display text-3xl text-slate-900">{t.errors.notFoundTitle}</h1>
        <p className="max-w-md text-slate-500">{t.errors.notFoundBody}</p>
        <Link to="/situs" className={buttonClass("primary", "lg")}>
          {t.errors.notFoundCta}
        </Link>
      </div>
    </main>
  );
}

export default function NotFoundRoute() {
  return <NotFoundPage />;
}
